import { FC, useEffect } from 'react';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import LawFirstLevelTable from './lawComponents/LawFirstLevelTable';
import {
  addAdditionalTitleBarComponents,
  removeTitleBarComponent,
} from '../../../../redux/pages/actions';
import { useDispatch } from 'react-redux';
import { Select } from '../../../../types/redux/pages/PagesStore';
import {
  APPEND_NEW_SELECT_TO_TITLEBAR,
  REMOVE_SELECT_FROM_TITLEBAR,
} from '../../../../types/redux/pages/pageTypes';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useLawPageQuery } from '../../../../api/rs-hg/risk/hooks/queries';
import {
  type LawPayload,
} from '../../../../api/rs-hg/risk/law.types';
import useTitleBarSelect from '../../../../hooks/useTitleBarSelect';
import { HistoricalTableNew } from '../../ucits/law/lawComponents/HistoricalTable';

const RiaifLaw: FC<FundInfoComponentProps> = ({
  fundId,
  fundName,
  positionDate,
}) => {
  const dispatch = useDispatch();
  const currentOrHistorical = useTitleBarSelect('dataDisplay');
  const isHistorical = currentOrHistorical === 'historical';

  const lawQuery = useLawPageQuery('RIAIF', fundId, positionDate, isHistorical);

  useEffect(() => {
    const selectsToAdd: Select[] = [
      {
        titleBarTitle: 'Data Display: ',
        titleBarKey: 'dataDisplay',
        values: [
          {
            label: 'Current',
            value: 'current',
          },
          {
            label: 'Historical',
            value: 'historical',
          },
        ],
        displayOnOverviewPage: false,
        aValueIsAlwaysSelected: true,
        currentValue: 'current',
      },
    ];

    dispatch(
      addAdditionalTitleBarComponents(
        selectsToAdd,
        APPEND_NEW_SELECT_TO_TITLEBAR,
      ),
    );

    return () => {
      dispatch(
        removeTitleBarComponent('dataDisplay', REMOVE_SELECT_FROM_TITLEBAR),
      );
    };
  }, [dispatch]);

  if (isHistorical) {
    return <HistoricalTableNew activeFund={fundId} />;
  }

  return (
    <QueryBoundary<LawPayload>
      isLoading={lawQuery.isLoading}
      isFetching={lawQuery.isFetching}
      isError={lawQuery.isError}
      error={lawQuery.error}
      data={lawQuery.data?.data}
      loadingMessages={
        ['Loading RIAIF Law Data...', 'Just a few more seconds...']
      }
      noDataMessage="No data available for this date."
      errorMessage="Unable to load RIAIF law data."
    >
      {(pageData) => (
        <LawFirstLevelTable
          pageData={pageData}
          isFetching={lawQuery.isFetching}
          activeFundName={fundName}
          activeFund={fundId}
          positionDate={lawQuery.data?.returned_position_date || ''}
          lawName="RIAIF"
        />
      )}
    </QueryBoundary>
  );
};

export default RiaifLaw;
